import styles from './PollProgressBar.module.less';

const PollProgressBar = ({ text, value, max, clickable }) => {
    const percent = Math.round((value / max) * 100);
    return (
        <div className={[styles.progressBar, clickable ? styles.clickable : ''].join(' ')}>
            <div className={styles.progress} style={{ width: `${percent}%` }} />
            <div className={styles.textContainer}>
                <div className={styles.text}>{text}</div>
            </div>
        </div>
    );
};

export default PollProgressBar;
